<script>
	import { afterUpdate, onMount } from 'svelte'
	import { Circle2 } from 'svelte-loading-spinners'
	import Time from 'svelte-time'
	import EmailForm from './EmailForm.svelte'

	const current = new URL(window.location.href)
	const emailId = current.pathname.split('/').find(p => /^[0-9a-fA-F]{24}$/.test(p)) ?? current.searchParams.get('e')
	const securityHash = current.searchParams.get('s')
	const wantsPrint = current.searchParams.get('print') === 'true'
	const printElementId = current.searchParams.get('printElementId')

	export const isMissingEmailId = !emailId

	export let title = ''
	export let isLoading = true
	export let isNotFound = false
	export let isNotCorrectHash = false
	export let isTooManyRequests = false

	export let created
	export let subject
	export let sender
	export let recipient
	export let isLive
	export let isBounced
	export let html

	onMount(
		async () => {
			try {
				const res = await fetch(
					`https://api.parcellab.com/email-web-view/${emailId}?s=${securityHash}`,
				)
				const email = await res.json()

				if (email.error) {

					if (/Access denied/.test(email.error)) {
						isNotCorrectHash = true
					} else if (/Too many requests/.test(email.error)) {
						isTooManyRequests = true
					} else {
						isNotFound = true
					}

				} else {

					title = email.subject + ' | '
				
					created = email.created
					subject = email.subject
					sender = email.sender
					recipient = email.recipient
					isLive = email.live
					isBounced = email.bounce
					html = email.content

				}

			} catch (e) {
				isNotFound = true

			} finally {
				isLoading = false
			}
		}
	)

	afterUpdate(
		() => {
			if (!isLoading && wantsPrint) {

				const printContent = printElementId
					? document.getElementById(printElementId).innerHTML
					: null

				if (printContent) {
					const originalContent = document.body.innerHTML
					document.body.innerHTML = printContent
					setTimeout(() => {
						window.print()
						document.body.innerHTML = originalContent
					}, 300)
				} else {
					setTimeout(() => { window.print() }, 300)
				}

			}
		}
	)
</script>

<svelte:head>
	<title>{title} Email Web View</title>
</svelte:head>

<main>
	{#if isLoading}

		<center style="margin-top: 40px;">
			<Circle2 size="60" colorOuter="#000E31" colorCenter="#002172" colorInner="#5ECFFB" unit="px" duration="1s"></Circle2>
		</center>

	{:else}

		{#if isMissingEmailId}

			<p>Nothing requested.</p>
		
		{:else if isTooManyRequests}

			<p>You are requesting this page too often. For security and privacy reasons, you have been blocked for 60 seconds. Please try again in 1 minute.</p>

		{:else if isNotCorrectHash}

			<EmailForm />

		{:else if isNotFound}
		
			<p>Email not found. For privacy reasons, your web link is only available for 90 days.</p>

		{:else}

		<table class="meta">
			<tr>
				<td></td>
				<td class="small">
					<Time timestamp="{created}" format="ddd, DD. MMM YYYY[, at ]HH:mm:ss" />
					(<Time timestamp="{created}" relative />)
				</td>
			</tr>
			<tr>
				<td class="label">Subject</td>
				<td>{subject}</td>
			</tr>
			<tr>
				<td class="label">From</td>
				<td>{sender}</td>
			</tr>
			<tr>
				<td class="label">To</td>
				<td>
					{#if isLive}
						{recipient}
					{:else}
						<mark>TEST EMAIL: Not sent to customer</mark>
					{/if}
				</td>
			</tr>
			{#if isBounced}
				<tr>
					<td></td>
					<td>
						<span style="color: red;">
							🚫 E-mail bounced and could not be delivered
						</span>
					</td>
				</tr>
			{/if}
		</table>

		<div>{@html html}</div>
			
		{/if}

	{/if}
</main>

<style>

	main {
		padding: 0;
		margin: 0 auto;
		font-size: 11pt;
	}

	@media (max-width: 640px) {
		main {
			font-size: 10pt;
		}
	}

	p {
		margin-left: 12px;
	}

	table.meta {
		margin-top: 12px;
		margin-bottom: 8px;
		margin-left: 12px;
	}

	@media (min-width: 640px) {
		table.meta {
			margin-left: 26%;
		}
	}

	table.meta td.label {
		text-align: right;
		font-weight: bold;
		padding-right: 14px;
	}

	table.meta td.small {
		font-size: 8pt !important;
	}

</style>